
import { DashboardMenu } from "../../data/menu"
import DashboardButton from "../Setting/dashboardButton";
import BreadCrump from "../tools/breadcrump"
import { useTranslation } from 'react-i18next';


export default function FeatureIndex() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Feature',
            url: null
        },
    ]
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4   h-[100vh] mb-5 directions ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Feature" DashboardMenu={DashboardMenu}></DashboardButton>

            </div>

        </>
    )
}